export default {
  name: 'Collapsible',
  props: {
    shouldCollapse: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    collapseSection(element) {
      // var sectionHeight = element.scrollHeight
      var elementTransition = element.style.transition
      element.style.transition = ''
      requestAnimationFrame(function() {
        element.style.height = 0 + 'px'
         element.style.minHeight = 0 + 'px'
        element.style.transition = elementTransition
        requestAnimationFrame(function() {
          element.style.height = 0 + 'px'
        })
      })
      element.setAttribute('data-collapsed', 'true')
    },
    expandSection(element) {
      var sectionHeight = element.scrollHeight
      element.style.minHeight = sectionHeight + 'px'
      element.style.height = 'auto'
      element.setAttribute('data-collapsed', 'false')
    }
  }
}